"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.useDeviceType = exports.DeviceTypeProvider = exports.MS_TO_CHANGE_SCREEN_TYPE_IN_DEVICE_MODE = void 0;
const debounce_1 = __importDefault(require("lodash/debounce"));
const min_1 = __importDefault(require("lodash/min"));
const react_1 = require("react");
const libs_polyfills_1 = require("@hotelplan/libs.polyfills");
const DeviceTypeContext_types_1 = require("./DeviceTypeContext.types");
const getDeviceTypeByScreenWidth_1 = __importDefault(require("./getDeviceTypeByScreenWidth"));
const normalizeDeviceType_1 = __importDefault(require("./normalizeDeviceType"));
const DeviceTypeContext = (0, react_1.createContext)({
    type: DeviceTypeContext_types_1.DeviceType.Desktop,
    serverType: DeviceTypeContext_types_1.DeviceType.Desktop,
    mobile: false,
    tablet: false,
    desktop: true,
});
function getContextValueByType(type, serverType) {
    return {
        type: type === DeviceTypeContext_types_1.DeviceType.Tablet ? DeviceTypeContext_types_1.DeviceType.Desktop : type,
        serverType,
        mobile: type === DeviceTypeContext_types_1.DeviceType.Mobile,
        tablet: false,
        desktop: type === DeviceTypeContext_types_1.DeviceType.Tablet || type === DeviceTypeContext_types_1.DeviceType.Desktop,
    };
}
function getViewportWidth() {
    var _a;
    // innerWidth is buggy when layout is flex
    // minimal width would be the most correct
    return (0, min_1.default)([window.innerWidth, window.outerWidth, (_a = window.visualViewport) === null || _a === void 0 ? void 0 : _a.width].filter(Boolean));
}
exports.MS_TO_CHANGE_SCREEN_TYPE_IN_DEVICE_MODE = 500;
const DeviceTypeProvider = props => {
    const { deviceType: serverType, children } = props;
    const [value, setValue] = (0, react_1.useState)(getContextValueByType(serverType, serverType));
    (0, react_1.useEffect)(() => {
        if (typeof window === 'undefined') {
            return;
        }
        const normalizedType = (0, normalizeDeviceType_1.default)(serverType);
        const browserType = (0, normalizeDeviceType_1.default)((0, getDeviceTypeByScreenWidth_1.default)(getViewportWidth()));
        if (normalizedType !== browserType) {
            setValue(getContextValueByType(browserType, serverType));
        }
        const onResizeChange = (0, debounce_1.default)(() => {
            const nextType = (0, normalizeDeviceType_1.default)((0, getDeviceTypeByScreenWidth_1.default)(getViewportWidth()));
            setValue(prevState => {
                // keep same object link when type is not changing
                if (prevState.type === nextType)
                    return prevState;
                return getContextValueByType(nextType, serverType);
            });
        }, exports.MS_TO_CHANGE_SCREEN_TYPE_IN_DEVICE_MODE);
        window.addEventListener('resize', onResizeChange, libs_polyfills_1.optionsWithPassive);
        window.addEventListener('deviceorientation', onResizeChange, libs_polyfills_1.optionsWithPassive);
        return () => {
            window.removeEventListener('resize', onResizeChange);
            window.removeEventListener('deviceorientation', onResizeChange);
        };
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    return (0, react_1.createElement)(DeviceTypeContext.Provider, { value }, children);
};
exports.DeviceTypeProvider = DeviceTypeProvider;
function useDeviceType() {
    return (0, react_1.useContext)(DeviceTypeContext);
}
exports.useDeviceType = useDeviceType;
//# sourceMappingURL=DeviceTypeContext.js.map